

module.exports = __webpack_require__.stylable.create(
    "DropDownCategories1266808962",
    {"classes":{"root":"DropDownCategories1266808962__root","TPADropdownBase":"","dropdown":"Dropdown4162579615__dropdown","title":"DropdownOption3509205415__title","arrowIcon":"DropdownBase3597315062__arrowIcon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    10,
    "DropDownCategories1266808962",
    null
);
